/**
 * Generate a class name string with modifiers
 *
 * Example:
 * addModifiers('MyClass', ['foo', 'bar', 'baz'])
 * >> "MyClass MyClass--foo MyClass--bar MyClass--baz"
 */
const addModifiers = (name = '', modifiers = []) =>
  modifiers
    .reduce(
      (classStr, modifier) => classStr.concat(`${name}--${modifier}`),
      [name],
    )
    .join(' ');

export default addModifiers;
